export const SIGNUP_PAGE = "/signup";
export const LOGIN_PAGE = "/login";
export const SALES_PAGE = "/sales";
export const PRODUCTS_PAGE = "/articles";
export const PRODUCTS_FORM_PAGE = "/inventory-module/articles/form";
export const UM_PAGE = "/unitesMesure";
export const ENTREPOT_PAGE = "/entrepots";
export const CATEGORY_PAGE = "/categories";
export const CATEGORY_FORM_PAGE = "/categories/form/:id?";
export const DASHBOARD_PAGE = "/dashboard";
export const STOCK_PAGE = "/stock";
export const BARCODE_PAGE = "/stock/barcode";
export const SALES_HISTORY_PAGE = "/sales/history";
export const REFUND_PAGE = '/refund';
export const REFUNDS_HISTORY_PAGE = "/refund/history";
export const SETTINGS_PAGE = "/settings";
export const PROFILE_PAGE = "/profile";
export const DOCUMENTATION_PAGE = "/documentation";
export const DEVIS_PAGE = "/sales/devis";
export const SUPPLIER_PAGE = "/suppliers";
export const PURCHASE_PAGE = "/achats";
export const BUYS_HISTORY_PAGE = "/achats/history";
export const DELIVERY_NOTE_PAGE = "/deliveryNotes/history";
export const BL_PAGE = "/ventes/bl";
export const PAIMENT_PAGE = "/paiements";
export const CLIENT_PAGE = "/clients";
export const CLIENT_FORM_PAGE = "/clients/new";
export const CLIENT_EDIT_PAGE = "/clients/:id/edit";
export const INVOICE_PAGE = "/ventes/factures";
export const NEW_INVOICE_PAGE = "/ventes/factures/new";
export const COMPANY_PAGE = "/companies/newCompany";
export const COMMANDE_PAGE = "/commandes";
export const INVENTORY_PAGE = "/inventory";
export const PURCHASE_ORDERS_PAGE = '/purchase-orders';
export const PURCHASE_RETURN_PAGE = '/purchase-returns';
export const CUSTOMER_PAYMENTS_PAGE = '/customer-payments';
export const SUPPLIER_PAYMENTS_PAGE = '/supplier-payments';
export const EXPENSES_PAGE = '/expenses';
export const RECEPTION_PAGE = '/reception';
export const SUPPLIER_INVOICE_PAGE = '/supplier-invoice';
export const TRANSPORTEUR_PAGE = '/transporteurs';
export const JOURNAL_PAGE = '/journal';
export const GENERAL_LEDGER_PAGE = '/general-ledger';
export const BALANCE_SHEET_PAGE = '/balance-sheet';
export const TRIAL_BALANCE_PAGE = '/trial-balance';
export const TAXES_PAGE = '/taxes';
export const CASH_FLOW_PAGE = '/cash-flow';
export const CHECK_MANAGEMENT_PAGE = '/check-management';
export const BANK_RECONCILIATION_PAGE  = '/bank-reconciliation';
export const BUDGET_PAGE = '/budget';
export const CUSTOMER_PAGE  = '/etat/clients';
export const SALES_REPORT_PAGE = '/etat/ventes';

// Ajouter ces constantes aux routes existantes
export const LOT_PAGE = "/stock/lots";
export const LOT_FORM_PAGE = "/stock/lots/form";
export const LOT_DETAILS_PAGE = "/stock/lots/:numeroLot";
export const MOUVEMENT_STOCK_PAGE = "/stock/mouvements";
export const CUSTOMER_RETURNS_PAGE = "/ventes/retours-client";
export const CUSTOMER_RETURN_FORM_PAGE = "/ventes/retours-client/form/:id?";
export const CUSTOMER_RETURN_DETAIL_PAGE = "/ventes/retours-client/:id";

// Comptabilité
export const RELEVE_COMPTE_PAGE = "/comptabilite/releve-compte";
export const BALANCE_COMPTABLE_PAGE = "/comptabilite/balance";
export const GRAND_LIVRE_PAGE = "/comptabilite/grand-livre";
export const SYNTHESE_COMPTABLE_PAGE = "/comptabilite/synthese";

//Comptoire routes
export const POS_PAGE = "/comptoire";
export const CBL_PAGE = "/comptoire/list";
export const PAY_PAGE = "/comptoire/payments";
export const PAY_FORM_NEW = "/comptoire/payments/new";
export const PAY_FORM_EDIT = "/comptoire/payments/edit";
export const RETOUR_PAGE = "/comptoire/retours";
export const RETOUR_FORM_NEW = "/comptoire/retours/new";
export const RETOUR_FORM_EDIT = "/comptoire/retours/edit";
export const CPMT_STOCK_PAGE = "/comptoire/stocks";
export const CPMT_PRODUCTS_PAGE = "/comptoire/articles";
export const CPMT_PRODUCTS_FORM_NEW = "/comptoire/articles/new";
export const CPMT_PRODUCTS_FORM_EDIT = "/comptoire/articles/edit";
export const CPMT_RECEPTION_PAGE = "/comptoire/reception";
export const CPMT_RECEPTION_FORM_PAGE = "/comptoire/reception/new";
export const CPMT_TRANSFER_PAGE = "/comptoire/transfere";
export const CPMT_INVOICES_PAGE = "/comptoire/factures";
// Module Routes
export const MODULES_PAGE = "/modules";
export const DASHBOARD_MODULE_PAGE = "/dashboard";
export const INVENTORY_MODULE_PAGE = "/inventory-module/*";
export const SALES_MODULE_PAGE = "/sales-module/*";
export const PURCHASES_MODULE_PAGE = "/purchases-module/*";
export const FINANCE_MODULE_PAGE = "/finance-module/*";
export const ACCOUNTING_MODULE_PAGE = "/accounting-module/*";
export const REPORTS_MODULE_PAGE = "/reports-module/*";
export const SETTINGS_MODULE_PAGE = "/settings-module/*";

export const POS_MODULE_PAGE = "/pos-module/*";
export const SHIFT_MODULE_PAGE = "/shifts-module/*";
export const SHIFT_DETAIL_PAGE = "/shifts-module/shifts/details";


export const REGLEMENTS_PAGE = "/reglements";
export const REGLEMENT_FORM_PAGE = "/finance-module/payments/edit";
export const REGLEMENTS_REPORT_PAGE = "/reglements/rapport";


export const RECOUVREMENT_MODULE_PAGE = "/recouvrement-module/*";
export const RECOUVREMENT_CALENDAR_PAGE = "/recouvrement-module/calendar";
export const RECOUVREMENT_LIST_PAGE = "/recouvrement-module/list";
